module.exports = __webpack_public_path__ + "static/media/Bipul Deka.7173a5e7.jpg";